// extracted by mini-css-extract-plugin
export var box = "CookieConsent-module--box--9de69";
export var content = "CookieConsent-module--content--a4f74";
export var options = "CookieConsent-module--options--21d34";
export var overlay = "CookieConsent-module--overlay--1bb95";